import configuration from './../config.json'
import reportService from '../shared/services/reportService'
import CookieService from './../shared/services/cookiesService'
import { setLogout } from './authActions'

const REQUEST_SAVE_REPORTS = 'REQUEST_SAVE_REPORTS'
const REQUEST_SAVE_REPORT = 'REQUEST_SAVE_REPORT'
const RESPONSE_SAVE_REPORT = 'RESPONSE_SAVE_REPORT'
const REQUEST_SAVE_REPORT_FAILURE = 'REQUEST_SAVE_REPORT_FAILURE'
const CLEAR_SAVE_REPORTS = 'CLEAR_SAVE_REPORTS'

const requestSaveReportsAction = (report, selectedCars) => {
  return {
    type: REQUEST_SAVE_REPORTS,
    payload: { report, selectedCars }
  }
}

const setRequestSaveReports = (report, selectedCars) => {
  return (dispatch) => {
    dispatch(requestSaveReportsAction(report, selectedCars))
  }
}

const requestSaveReportAction = (reportId, carId) => {
  return {
    type: REQUEST_SAVE_REPORT,
    payload: { reportId, carId }
  }
}

const responseSaveReportAction = (reportId, carId) => {
  return {
    type: RESPONSE_SAVE_REPORT,
    payload: { reportId, carId }
  }
}

const requestSaveReportFailureAction = (reportId, carId, errors) => {
  return {
    type: REQUEST_SAVE_REPORT_FAILURE,
    payload: { reportId, carId, errors }
  }
}

const saveReport = (id, options) => {
  return (dispatch) => {
    dispatch(requestSaveReportAction(id, options.unitId))

    reportService.saveReport(id, options)
      .then((result) => {
        CookieService.updateExpires(configuration.cookieName, 12)

        dispatch(responseSaveReportAction(id, options.unitId))
      })
      .catch((error) => {
        dispatch(requestSaveReportFailureAction(id, options.unitId, error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

const clearSaveReportsAction = () => {
  return {
    type: CLEAR_SAVE_REPORTS
  }
}

const clearSaveReports = () => {
  return (dispatch) => {
    dispatch(clearSaveReportsAction())
  }
}

export {
  setRequestSaveReports,
  requestSaveReportsAction,
  saveReport,
  requestSaveReportAction,
  responseSaveReportAction,
  requestSaveReportFailureAction,
  clearSaveReports,
  clearSaveReportsAction,
  REQUEST_SAVE_REPORTS,
  REQUEST_SAVE_REPORT,
  RESPONSE_SAVE_REPORT,
  REQUEST_SAVE_REPORT_FAILURE,
  CLEAR_SAVE_REPORTS
}